import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ScrollText } from "lucide-react";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/logs").then((r) => setLogs(r.data)); }, []);

  return (
    <div data-testid="admin-logs">
      <h1 className="font-serif font-light text-4xl text-petrol mb-2">Log attività</h1>
      <p className="text-muted-foreground mb-8">Registro delle azioni amministrative</p>

      <div className="bg-card border border-line rounded-sm overflow-hidden">
        {logs.length === 0 ? (
          <p className="p-6 text-muted-foreground text-sm">Nessuna attività registrata.</p>
        ) : (
          <ul className="divide-y divide-line">
            {logs.map((l) => (
              <li key={l.id} className="px-5 py-4 flex items-center gap-4 text-sm">
                <ScrollText size={16} className="text-gold shrink-0" />
                <span className="text-petrol font-medium w-40 shrink-0">{l.action}</span>
                <span className="text-muted-foreground flex-1">{l.detail}</span>
                <span className="text-muted-foreground/70 text-xs">{new Date(l.created_at).toLocaleString("it-IT")}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
